export const PASSWORD_MIN_LENGTH = 16;

// Matched against the whole value by the browser `pattern` attribute.
export const PASSWORD_PATTERN =
  "(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9\\s]).{16,}";

export const PASSWORD_TITLE =
  "Use at least 16 characters with uppercase, lowercase, a digit, and a symbol";

export const PASSWORD_PLACEHOLDER =
  "At least 16 characters with upper & lower case, a digit, and a symbol";

const passwordRegExp = new RegExp(`^${PASSWORD_PATTERN}$`);

export function isStrongPassword(value) {
  return passwordRegExp.test(value || "");
}

export function getPasswordRules(value = "") {
  const password = value || "";
  return [
    {
      id: "length",
      label: `At least ${PASSWORD_MIN_LENGTH} characters`,
      met: password.length >= PASSWORD_MIN_LENGTH,
    },
    {
      id: "upper",
      label: "At least one uppercase letter (A–Z)",
      met: /[A-Z]/.test(password),
    },
    {
      id: "lower",
      label: "At least one lowercase letter (a–z)",
      met: /[a-z]/.test(password),
    },
    {
      id: "number",
      label: "At least one number (0–9)",
      met: /\d/.test(password),
    },
    {
      id: "special",
      label: "At least one special character (e.g. ! @ # $ % ^ & *)",
      met: /[^A-Za-z0-9\s]/.test(password),
    },
  ];
}

export function passwordStrength(value) {
  const rules = getPasswordRules(value);
  const met = rules.filter((rule) => rule.met).length;
  const labels = ["", "Weak", "Weak", "Fair", "Good", "Strong"];
  const colors = ["#d1d5db", "#e11d48", "#e11d48", "#f59e0b", "#22c55e", "#16a34a"];
  return {
    rules,
    met,
    total: rules.length,
    label: value ? labels[met] : "",
    color: value ? colors[met] : "#d1d5db",
  };
}

export function passwordInputProps(props = {}) {
  const provided = props.placeholder ?? props.placeHolder;
  const useDefaultPlaceholder =
    provided == null || /8\+/.test(String(provided));
  return {
    minLength: props.minLength || PASSWORD_MIN_LENGTH,
    pattern: props.pattern || PASSWORD_PATTERN,
    title: props.title || PASSWORD_TITLE,
    placeholder: useDefaultPlaceholder ? PASSWORD_PLACEHOLDER : provided,
  };
}
